import { render, staticRenderFns } from "./Localizations.vue?vue&type=template&id=602ec43e&scoped=true&"
import script from "./Localizations.vue?vue&type=script&lang=js&"
export * from "./Localizations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602ec43e",
  null
  
)

export default component.exports